// Lógica de cálculos para el inventario

export function getTaxMultiplier(taxId: string, taxesList: any[] = []): number {
  if (!taxId) return 1;
  const tax = taxesList.find(t => String(t.id) === taxId)
  if (tax && tax.percentage !== undefined) {
    return 1 + (Number(tax.percentage) / 100)
  }
  return taxId === 'iva' ? 1.16 : taxId === 'ieps' ? 1.08 : 1
}

//Precio final
export function calculateFinalPrice(
  costWithoutTaxes: string,
  profitPercentage: string,
  taxId: string,
  taxesList: any[] = []
): string {
  if (!profitPercentage || !costWithoutTaxes) return '0.00'
  const cost = parseFloat(costWithoutTaxes)
  const price = cost * (1 + parseFloat(profitPercentage) / 100)
  return (price * getTaxMultiplier(taxId, taxesList)).toFixed(2)
}

// Precio de venta sin impuestos
export function calculateSalePrice(
  costWithoutTaxes: string,
  profitPercentage: string
): string {
  if (!profitPercentage || !costWithoutTaxes) return '0.00'
  const cost = parseFloat(costWithoutTaxes)
  return (cost * (1 + parseFloat(profitPercentage) / 100)).toFixed(2)
}

// Recalcular costos
export function recalculateCosts(
  baseCostWithoutTaxes: string,
  taxId: string,
  changed: 'without' | 'with' | 'tax',
  value: string,
  taxesList: any[] = []
): { costWithoutTaxes?: string; costWithTaxes?: string; taxId?: string } {
  const mult = getTaxMultiplier(taxId, taxesList)

  if (changed === 'without') {
    const num = parseFloat(value)
    return {
      costWithoutTaxes: value,
      costWithTaxes: isNaN(num) ? '' : (num * mult).toFixed(2),
    }
  }

  if (changed === 'with') {
    const num = parseFloat(value)
    return {
      costWithTaxes: value,
      costWithoutTaxes: isNaN(num) || mult === 0 ? '' : (num / mult).toFixed(2),
    }
  }

  // Cambio de impuesto - se recalcula costo con impuesto
  const newMult = getTaxMultiplier(value, taxesList)
  const num = parseFloat(baseCostWithoutTaxes)
  return {
    taxId: value,
    costWithTaxes: isNaN(num) ? '' : (num * newMult).toFixed(2),
  }
}

export function calculateTierPrices(
  baseCostWithoutTaxes: string,
  profitPercentage: number,
  discountPercentage: number,
  taxId: string,
  taxesList: any[] = []
): { salePrice: string; finalPrice: string } {
  const cost = parseFloat(baseCostWithoutTaxes) || 0
  const salePrice = cost * (1 + profitPercentage / 100) * (1 - discountPercentage / 100)
  const finalPrice = salePrice * getTaxMultiplier(taxId, taxesList)

  return {
    salePrice: salePrice ? salePrice.toFixed(2) : '',
    finalPrice: finalPrice ? finalPrice.toFixed(2) : '',
  }
}
